import Dictionary from './dictionary';
import PrintOptions from './print-options';
import QuestionOptionItem from './question-option-item';
import QUESTION_TYPES from './question-types';

export type ValueMapping = {
  questionId: string;
  value: number;
};

export type OptionRangeConfig = {
  min: number;
  max: number;
  optionId: string;
};

export enum TypeOfModification {
  ADD = 'ADD',
  OVERRIDE = 'OVERRIDE',
  COMPARE = 'COMPARE',
}

export enum CompareStrategy {
  MIN = 'MIN',
  MAX = 'MAX',
}

export type DependentsConfigSchema = {
  dependentQuestionId: string;
  typeOfModification: TypeOfModification;
  compareStrategy?: CompareStrategy; // Only used when typeOfModification is COMPARE
};

export type CompareValues = {
  firstCompareId: string;
  secondCompareId: string;
};

type QuestionItem = {
  _id: string;
  disabled?: boolean;
  hidden?: boolean;
  title: Dictionary<string>;
  tooltip?: Dictionary<string>;
  type?: QUESTION_TYPES;
  notes?: boolean;
  optional?: boolean;
  order: number;
  description?: {
    text?: Dictionary<string>;
    imgUrl?: Dictionary<string>;
  };
  options: QuestionOptionItem[];
  printOptions?: {
    portrait: PrintOptions;
    landscape: PrintOptions;
  };
  compareValues?: CompareValues[];
  isExcludeQuestionFromFinalScore?: boolean;
  dependents?: DependentsConfigSchema[];
  dependsOn?: string[];
  overrideValue?: string;
  overrideValues?: any;
  optionRangeConfig?: OptionRangeConfig[];
  sourceQuestionsValueMapping?: ValueMapping[];
};

export default QuestionItem;
